import { tv } from 'tailwind-variants';

import { buttons } from './buttons';
import { fontStyles } from './typography';

export const tabsStyles = tv({
  slots: {
    container: [
      'transition-colors',
      'duration-150',
      'ease-in-out',
      'flex',
      'gap-2',
      'overflow-x-auto',
      'scrollbar-hide',
    ],
    tab: ['transition-colors', 'duration-150', 'ease-in-out'],
  },
  variants: {
    active: {
      true: '',
      false: '',
    },
    variant: {
      secondary: {
        tab: buttons({
          size: 'small',
          shape: 'rounded',
          color: 'gray',
          class: [
            'data-[state=active]:bg-token-purple-300',
            'data-[state=active]:hover:bg-token-purple-300',
            'data-[state=active]:text-token-purple-1100',
            'data-[state=active]:shadow-purple',
          ],
        }),
      },
      tertiary: {
        container: ['gap-1'],
        tab: buttons({
          size: 'small',
          shape: 'rounded',
          color: 'transparent',
          class: ['data-[state=active]:bg-token-alphalight-200'],
        }),
      },
      underlined: {
        container: ['border-b', 'border-token-gray-300', 'pb-2', 'gap-5'],
        tab: [
          fontStyles({
            variant: 'BODY_MD',
            class: [
              'text-token-gray-800',
              'hover:text-token-gray-900',
              'active:text-token-gray-1600',
              'data-[state=active]:border-b-2',
              'data-[state=active]:border-token-purple-900',
              'data-[state=active]:text-token-purple-900',
              'ficus-visible:outline-[3px]',
              'ficus-visible:outline-token-gray-600',
              'disabled:text-token-gray-600',
              'whitespace-nowrap',
            ],
          }),
        ],
      },
      card: {
        container: ['gap-3'],
        tab: [
          fontStyles({
            variant: 'H5',
            class: [
              'px-2',
              'py-0.5',
              'text-token-gray-700',
              'hover:text-token-gray-900',
              'active:text-token-gray-1600',
              'ficus-visible:outline-[3px]',
              'ficus-visible:outline-token-gray-600',
              'disabled:text-token-gray-600',
              'data-[state=active]:text-token-gray-1600',
              'whitespace-nowrap',
              'rounded-sm',
            ],
          }),
        ],
      },
    },
  },
  compoundVariants: [
    {
      variant: 'secondary',
      active: true,
      class: {
        tab: [
          'bg-token-purple-300',
          'hover:bg-token-purple-300',
          'text-token-purple-1100',
          'shadow-purple',
        ],
      },
    },
    {
      variant: 'tertiary',
      active: true,
      class: {
        tab: ['bg-token-alphalight-200'],
      },
    },
    {
      variant: 'underlined',
      active: true,
      class: {
        tab: ['border-b-2', 'border-token-purple-900', 'text-token-purple-900'],
      },
    },
    {
      variant: 'card',
      active: true,
      class: {
        tab: 'text-token-gray-1600',
      },
    },
  ],
  defaultVariants: {
    active: false,
  },
});
